import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextLibraryEntry } from 'editor/src/store/editorModules/textLibrary/types';

import styles from './index.module.scss';

interface Props {
  entries: TextLibraryEntry[];
  onSelect: (id: string) => void;
}

function EntryList({ entries, onSelect }: Props) {
  const { t } = useTranslation();

  if (!entries.length) {
    return <div className={cn(styles.empty, 'cy-text-library-empty')}>{t('editor-text-library-no-matches')}</div>;
  }

  return (
    <ul className={styles.list}>
      {entries.map((entry) => {
        const firstLine = entry.verses[0].split('\n')[0];
        return (
          <li key={entry.id}>
            <button
              type="button"
              className={cn(styles.entry, 'cy-text-library-entry')}
              onClick={() => onSelect(entry.id)}
            >
              {entry.number && <span className={styles.number}>{entry.number}</span>}
              <span className={styles.entryText}>
                <span className={styles.entryTitle}>{entry.title}</span>
                {/* a one-line entry often repeats its title: nothing to preview then */}
                {!firstLine.startsWith(entry.title) && <span className={styles.entryFirstLine}>{firstLine}</span>}
                {entry.credits && <span className={styles.entryCredits}>{entry.credits}</span>}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export default React.memo(EntryList);
